<template>
  <iframe :src="iframeURL" :style="height?'height:'+height+'px':'height:calc(100vh - 50px)'"/>
</template>

<script>
import { useQueryStore } from 'src/stores/QueryStore.js'
import { useAuthStore } from 'src/stores/AuthStore.js'

export default {
  name: 'Framelink',
  props: {
    qryID: String,
    queryParams: Array,
    setupToken: String,
    frameLinkSrc: String,
    height: Number
  },
  data() {
    return {
      iframeURL: "",
      queryID: this.qryID ? this.qryID : this.$route.params.id,
      iframeHeight: 200
    }
  },

  methods: {
    init() {
      const authStore = useAuthStore()
      const queryStore = useQueryStore()
      this.$q.loading.show()
      //console.warn("Init Framelink queryID:", this.queryID, ", frameLinkSrc:", this.frameLinkSrc)
      authStore.sessionTouch().then(() => {
        let tokendata = safeParseJSON(atob(authStore.sessionToken.split('.')[1]))
        if (!this.frameLinkSrc || this.frameLinkSrc == "") {
          queryStore.getQueryMeta(this.queryID)
            .then((queryMeta) => {
              let paramSep = "?"
              if (queryMeta.frameLink.includes("?")) paramSep = "&"
              let param = paramSep + "sesid=" + tokendata.sessionID + "&sid=" + PP_CONST.SITE_ID
              this.iframeURL = queryMeta.frameLink + encodeGUID(param)
              this.$q.loading.hide()
            })
            .catch(error => {
              this.$q.loading.hide()
              console.log(error)
              this.eventBus.globalErrorHandling(this.$t('framelinkLoadingError'), error)
            })

        } else {
          let param = ""
          let paramSep = "?"
          if (this.frameLinkSrc.includes("?")) paramSep = "&"
          this.queryParams.forEach((myParam, idx) => {
            if (myParam.value) {
              param += myParam.name + "=" + myParam.value
              param += "&"
            }
          })
          param = paramSep + param + "sesid=" + tokendata.sessionID + "&sid=" + PP_CONST.SITE_ID + "&queryID=" + this.queryID
          this.iframeURL = this.frameLinkSrc + encodeGUID(param)
          this.$q.loading.hide()
        }
      }).catch(error => {
        this.$q.loading.hide()
        console.log(error)
        this.eventBus.globalErrorHandling(this.$t('framelinkLoadingError'), error)
      })
    }
  },

  mounted: function () {
    this.init();
  }
}
</script>

<style lang="sass">
iframe
  width: 100%
  box-sizing: border-box
  border: none
  margin-bottom: -10px
</style>
